import IconComponent from "@CubeComponents/icons";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

const modulesMapper: any = {
  measurements: "https://support.cube.ms/ebd//22dde45767ab8195b034c62e74458b73",
  general: "https://support.cube.ms/ebd//253de45767ab80f49c72d6992a5610e2?v=266de45767ab802ba907000cc6841787",
};

const HelpSection = ({ isDragging = false, handleHelpSectionClick }: any) => {
  const helpSectionState: any = useSelector((state: any) => state.helpSectionState);
  const [imageSrc, setImageSrc] = useState<any>(modulesMapper[helpSectionState.module] || modulesMapper["general"]);

  useEffect(() => {
    setImageSrc(modulesMapper[helpSectionState.module] || modulesMapper["general"]);
  }, [helpSectionState]);

  useEffect(() => {
    return () => {
      setTimeout(() => {
        globalThis.dispatchEvent(new Event("resize"));
      }, 0);
    };
  }, []);

  return (
    <div className="bg-white h-full overflow-auto w-full shadow-[4px_4px_15px_0px_rgba(65,92,171,0.15)] rounded-md">
      <div className="bg-white absolute flex justify-end items-center end-2 pe-4 top-1 h-9 w-32 z-50">
        <IconComponent onClick={handleHelpSectionClick} name="close" />
      </div>
      <iframe
        title="helpSection"
        style={isDragging ? { pointerEvents: "none" } : {}}
        src={imageSrc}
        width="100%"
        height="100%"
        allowFullScreen
      />
    </div>
  );
};

export default HelpSection;
